import { render, staticRenderFns } from "./PrivacyPolicyProductRegistrationModal.vue?vue&type=template&id=7455bdd2&scoped=true&lang=pug&"
import script from "./PrivacyPolicyProductRegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyProductRegistrationModal.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicyProductRegistrationModal.vue?vue&type=style&index=0&id=7455bdd2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455bdd2",
  null
  
)

export default component.exports